import { render, staticRenderFns } from "./SentimentEmoji.vue?vue&type=template&id=3eceea8a"
import script from "./SentimentEmoji.vue?vue&type=script&lang=js"
export * from "./SentimentEmoji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eceea8a')) {
      api.createRecord('3eceea8a', component.options)
    } else {
      api.reload('3eceea8a', component.options)
    }
    module.hot.accept("./SentimentEmoji.vue?vue&type=template&id=3eceea8a", function () {
      api.rerender('3eceea8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/conversations/contact-card/SentimentEmoji.vue"
export default component.exports